import { Link, useLocation, useMatch } from 'react-router-dom';
import './SidebarLink.scss';

interface Props {
  children: React.ReactNode;
  to: string;
  height?: number;
  useATag?: boolean;
  supressMatch?: boolean;
  excludeMatch?: string;
  selected?: boolean;
  boarderButtom?: boolean;
  greyBackground?: boolean;
  indent ?: number;
}
const doesPathMatch = (to, pathname) => {
  // Escape special characters in `to` to make it safe for regex
  const escapedTo = to.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  // Create a regex that matches the exact `to` as a path segment
  const regex = new RegExp(`(^|/)${escapedTo}(/|$)`);

  // Test if the pathname matches the `to` exactly
  return regex.test(pathname);
};
export function SidebarLink(props: Props) {
  const Tag: any = props.useATag ? 'a' : Link;
  let selected = props.selected;

  if (!props.supressMatch) {
    let location = useLocation();

    if (doesPathMatch(props.to, location.pathname)) {
      if (
        props.excludeMatch &&
        location.pathname.indexOf(props.excludeMatch) > -1
      ) {
        selected = false;
      } else {
      
        selected = true;
      }
    }
    
    // selected = useMatch(props.to) ? true : false;
  }

  return (
    <Tag
      {...(props.useATag ? { href: props.to } : { to: props.to })}
      style={{
        paddingLeft: (props.indent || 1) + 'em',
        height: (props.height || 44) + 'px',
        // display: 'flex',
        // alignItems: 'center',
        // padding: '0 1rem',
        // color: 'white',
        // textDecoration: 'none'
      }}
      className={`SidebarLink ${selected ? 'selected' : ''} ${
        props.boarderButtom ? 'borderBottom' : ''
      } ${props.greyBackground ? 'greyBackground' : ''}`}
    >
      <div className="chit" />
      {props.children}
    </Tag>
  );
}
